var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    workpacke-info-body-add
    font-weight-light
    `},[_c('div',{staticClass:"body-search",style:(`width: ${['TaktPlanAddWorkPackage', 'TaktPlanAddWBWorkPackage'].includes(_vm.$route.name)?'100%':'75px'}`)},[_vm._t("search")],2),_c('div',{staticClass:"body-workpackage",style:(`width: ${['TaktPlanAddWorkPackage', 'TaktPlanAddWBWorkPackage'].includes(_vm.$route.name)?'0%':'100%'}`)},[_vm._t("workpackage")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }